import request from '../../../../lib/request'

export async function getProduct(id, app) {
  try {
    const res = request(`default/product?id=${id}`, 'GET', undefined, undefined, app)
    return res || {}
  } catch (error) {
    return {}
  }
}
